import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/arav.png'


const _hoisted_1 = {
  id: "formulario",
  class: "p-6 min-h-[600px] bg-[#2d3fa6]"
}
const _hoisted_2 = { class: "container mx-auto p-6 max-w-3xl bg-white rounded-lg" }
const _hoisted_3 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_4 = { class: "w-full px-2" }
const _hoisted_5 = { class: "text-sm text-red-500 p-error" }
const _hoisted_6 = { class: "flex flex-wrap items-center justify-center py-2 mt-3" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_9 = { class: "pi pi-check mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSection = _resolveComponent("HeaderSection")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_FullScreenLoader = _resolveComponent("FullScreenLoader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSection),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.onSubmit,
        "validation-schema": _ctx.schema,
        class: "space-y-4 text-gray-700 TommyLight text-center"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "font-bold text-center text-3xl uppercase TommyBlack" }, "Credenciales", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "font-bold text-center text-xl" }, "Por favor complete el formulario para descargar su credencial", -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[1] || (_cache[1] = _createElementVNode("label", { class: "block mb-1" }, "Ingrese su número de documento o pasaporte", -1)),
                _createVNode(_component_Field, {
                  name: "documento",
                  modelValue: _ctx.formData.documento,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.documento) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "numeric",
                      placeholder: "Documento",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_5, [
                      _createVNode(_component_ErrorMessage, { name: "documento" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                type: "submit",
                class: "mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded",
                disabled: _ctx.isSubmitting
              }, [
                _withDirectives(_createElementVNode("i", _hoisted_8, null, 512), [
                  [_vShow, _ctx.isSubmitting]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_9, null, 512), [
                  [_vShow, !_ctx.isSubmitting]
                ]),
                _cache[2] || (_cache[2] = _createTextVNode("DESCARGAR CREDENCIAL "))
              ], 8, _hoisted_7)
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "container mx-auto py-5" }, [
              _createElementVNode("img", {
                class: "object-contain mx-auto",
                src: _imports_0,
                style: {"max-width":"200px"}
              })
            ], -1))
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ]),
    _createVNode(_component_FullScreenLoader, {
      visible: _ctx.isSubmitting,
      fullScreen: ""
    }, null, 8, ["visible"])
  ], 64))
}